import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, debounceTime } from 'rxjs';
import { PriceService } from './price.service';
import { ToastrService } from 'ngx-toastr';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.css'],
})
export class PriceComponent implements OnInit {

  bucketurl = environment.bucketUrl;

  displayedColumns: string[] = [
    'SNo',
    'color_ind',
    'exsh_price',
    'for_cd',
    'from_date',
    'sales_type',
    'variant_cd'
  ];

 
  dataSource: any[] = [];


  totalCount = 0;
  pageSize = 10;
  pageIndex = 0;

 
  isLoading$ = new BehaviorSubject<boolean>(false);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;


  searchInput = new FormControl('');

  constructor(
    private priceService: PriceService,
    private toastr: ToastrService
  ) {}


  ngOnInit() {
  this.getList(this.pageIndex, this.pageSize);

  this.searchInput.valueChanges
    .pipe(
      debounceTime(500),          // wait 0.5 sec after typing stops
      distinctUntilChanged()      // avoid duplicate calls
    )
    .subscribe(() => {
      this.pageIndex = 0;         // reset to first page
      this.paginator.firstPage(); 
      this.getList(this.pageIndex, this.pageSize);
    });
}


  // API CALL

  getList(pageIndex: number, pageSize: number){
  const offset = pageIndex * pageSize;
  const search = this.searchInput.value || '';

  this.isLoading$.next(true);

  this.priceService.getList(offset, pageSize, search).subscribe({
    next: (res: any) => {
      const body = res.body;

      if (body?.responseCode === 200) {
        this.dataSource = body.data.data;
        this.totalCount = body.data.total;
        const maxPageIndex = Math.floor((this.totalCount - 1) / pageSize);
        if (this.totalCount === 0 || pageIndex > maxPageIndex) {
            this.pageIndex = 0;
            this.paginator.firstPage();
        }
      } else {
        this.toastr.error(body?.responseMessage || 'Failed to load data');
      }

      this.isLoading$.next(false);
    },
    error: () => {
      this.isLoading$.next(false);
      this.toastr.error('Server error');
    }
  });
}





  // PAGINATOR 

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.getList(this.pageIndex, this.pageSize);
  }



  clearSearch() {
    this.searchInput.setValue('');
  }
}
